import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import {assembleSelectOptionsFromConfigData} from '../shared/reportJobFunctions';
import {jobBuilderStyles} from '../shared/styles-job-builder';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';

const CategoryInput = ({item}) => {
    return (
        <span className="job-category-select" style={jobBuilderStyles.buttonLabel}>
            <span style={jobBuilderStyles.buttonName}>{item.title}</span>
            <span className="job-select-description">
                <ReactMarkdown>{item.description}</ReactMarkdown>
            </span>
        </span>
    )
}

class JobReportBuilderCategorySelect extends Component {
    constructor(props) {
        super(props);
        const choicesCategory = assembleSelectOptionsFromConfigData('category', props.configData);
        this.state = {
            choicesCategory: choicesCategory,
            expanded: props.expanded,
            selectedCategory: {
                id: null,
                title: null
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            (nextProps.expanded && (!this.props.expanded || !this.state.expanded)) ||
            (!nextProps.expanded && (this.props.expanded || this.state.expanded))
        ) {
            this.setState({
                expanded: nextProps.expanded
            });
        }
        if (nextProps.selected.id !== this.props.selected.id) {
            this.setState({
                selectedCategory: {
                    id: nextProps.selected.id,
                    title: nextProps.selected.title
                }
            });
        }
    }

    renderCategoryOptions = (list) => {
        if (!list || list.length === 0) {
            return (
                [0].map(() => (
                    <span key="job-category-0"></span>
                ))
            )
        }
        return list.map((item, idx) =>
            <RadioButton
                key={`job-category-${item.id}-${idx}`}
                value={item.id}
                label={<CategoryInput item={item}/>}
                style={jobBuilderStyles.button}
                iconStyle={jobBuilderStyles.buttonIcon}
            />
        );
    };

    handleExpandChange = (expanded) => {
        this.setState({expanded: expanded});
    };

    handleCategorySelect = (e) => {
        const value = (e && e.target && e.target.value) ? e.target.value : '';
        let selectedCategory = {
            id: null,
            title: null
        };
        const choice = this.state.choicesCategory.find(r => r.id === value);
        if (choice) {
            selectedCategory.id = value;
            selectedCategory.title = choice.title;
        }
        this.setState({
            selectedCategory: selectedCategory
        }, () => {
            if (typeof this.props.onSelectCategory === 'function') {
                this.props.onSelectCategory(value);
            }
        });
    };

    render() {
        const {
            selected
        } = this.props;

        const {
            choicesCategory,
            expanded,
            selectedCategory
        } = this.state;

        const title = (selectedCategory.id) ? 'Category - ' + selectedCategory.title : 'Choose a Category';

        if (choicesCategory.length === 0) {
            return (
                <Card containerStyle={jobBuilderStyles.cardContainer} style={jobBuilderStyles.card}>
                    <CardHeader
                        title="No Categories Available"
                        actAsExpander={false}
                        showExpandableButton={false}
                        style={jobBuilderStyles.cardHeader}
                        textStyle={jobBuilderStyles.cardHeaderText}
                    />
                </Card>
            )
        }

        return (
            <Card
                expanded={expanded}
                onExpandChange={this.handleExpandChange}
                containerStyle={jobBuilderStyles.cardContainer}
                style={jobBuilderStyles.card}
            >
                <CardHeader
                    title={title}
                    actAsExpander={true}
                    showExpandableButton={true}
                    style={jobBuilderStyles.cardHeader}
                    textStyle={jobBuilderStyles.cardHeaderText}
                />
                <CardText expandable={true} style={jobBuilderStyles.cardText}>
                    <RadioButtonGroup
                        name="category"
                        onChange={(e) => this.handleCategorySelect(e)}
                        valueSelected={selected}
                        style={jobBuilderStyles.group}
                    >
                        {[...this.renderCategoryOptions(choicesCategory)]}
                    </RadioButtonGroup>
                </CardText>
            </Card>
        )
    }
}

JobReportBuilderCategorySelect.propTypes = {
    configData: PropTypes.object,
    expanded: PropTypes.bool,
    onSelectCategory: PropTypes.func,
    selected: PropTypes.string
};

JobReportBuilderCategorySelect.defaultProps = {
    configData: null,
    expanded: true
};

export default JobReportBuilderCategorySelect;



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportJobBuilderCategorySelect.js